var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSponsorsIconinline = function SvgSponsorsIconinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FD71AF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M27.44 7.987a2.759 2.759 0 0 0-.896-.638 2.618 2.618 0 0 0-2.115 0c-.335.148-.64.365-.897.638L23 8.554l-.533-.567a2.681 2.681 0 0 0-1.954-.862c-.733 0-1.435.31-1.954.862-.518.552-.809 1.3-.809 2.08s.291 1.529.81 2.08l.532.567L23 16.875l3.908-4.16.532-.567c.257-.274.46-.598.6-.955a3.108 3.108 0 0 0 0-2.252 2.962 2.962 0 0 0-.6-.954Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FD71AF",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m10 25 .894-1.789A4 4 0 0 1 14.472 21H19s2 0 2 2c0 3-7 2-7 2s2 .5 5-.099C23.413 24.021 28.5 19 30 22c1 2-4.5 6-6.5 7-2.215 1.107-8.5 1-8.5 1h-5m0-5H6.25v5H10m0-5v5"
  })));
};
export default SvgSponsorsIconinline;